/**
 * Shared deduplication and normalization utilities.
 * Used by Search, FiltersModal, Profile, and useSavedSearches.
 */

/** Case-insensitive deduplication of string lists, preserving original casing. */
export function dedupeCaseInsensitive(list) {
  const seen = new Set();
  const out = [];
  for (const raw of list) {
    const trimmed = (raw || '').trim();
    if (!trimmed) continue;
    const key = trimmed.toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    out.push(trimmed);
  }
  return out;
}

/** Normalize a list of search strings: trim, remove empties, dedupe, cap at 30. */
export function normalizeSearches(list) {
  if (!Array.isArray(list)) return [];
  const out = [];
  for (const raw of list) {
    const trimmed = (raw || '').trim();
    if (!trimmed) continue;
    out.push(trimmed);
  }
  return dedupeCaseInsensitive(out).slice(0, 30);
}

/** Deduplicate autocomplete suggestions by store name (main_text), one per chain. */
export function dedupeByStoreName(suggestions) {
  const seen = new Set();
  return suggestions.filter((s) => {
    const name = (s.structured_formatting?.main_text || s.description || '').trim().toLowerCase();
    if (!name || seen.has(name)) return false;
    seen.add(name);
    return true;
  });
}
